import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import ConversationApi from "Services/Conversation";

const ConversationDeleteModal = ({ openDialog, conversationId, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!conversationId) {
      dispatch(
        showSnackbar({
          message: "Conversation ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    ConversationApi.deleteConversation(conversationId).then(
      () => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Conversation deleted successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose(true);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while deleting conversation",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      }
    );
  };

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="xs">
      <DialogTitle>{"Are you sure delete this conversation ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Conversation ID: {conversationId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Disagree</Button>
        <Button onClick={handleDelete} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConversationDeleteModal;
